function clockReducer(state = {}, action = {}) {
  switch (action.type) {
    case 'START_CLOCK':
      return {
        ...state,
        running: true
      }
    case 'STOP_CLOCK':
      return {
        ...state,
        running: false
      }
    case 'UPDATE_TIME':
      return {
        ...state,
        clock: action.clock,
        lastTick: action.lastTick
      }
    case 'xtract-auth@reducer-logout':
      return {
        ...state,
        lastTick: null,
        clock: null
      }
    default:
      return state
  }
}

export default clockReducer
